<select 
    class="form-control"
    [name]="name"
    [id]="id"
    [required]="required"
    [disabled]="disabled"
    [ngModel]="ngModel || ''"
    (ngModelChange)="onChange($event ? $event : null)">
    <option value="">Selecione a região...</option>
    <option *ngFor="let regiao of regioes" [ngValue]="regiao.id">{{regiao.nome}}</option>
</select>